export const ORDERED_MODERATION_CATEGORIES = [
  'imminent_harm_to_self',
  'self_harm_non_imminent',
  'imminent_harm_to_others',
  'mental_emotional_distress',
  'violent_ideation_intent',
  'hate_speech',
  'sexual_content',
  'abusive_derogatory_language',
  'academic_misconduct',
  'illicit_illegal_content',
  'platform_manipulation',
  'pii_exposure',
  'spam_nonsense',
  'off_topic_misuse',
] as const;

export type ModerationCategoryName = (typeof ORDERED_MODERATION_CATEGORIES)[number];

export const ALWAYS_ON_SENSITIVITY_CATEGORIES: readonly ModerationCategoryName[] = [
  'imminent_harm_to_self',
  'self_harm_non_imminent',
  'imminent_harm_to_others',
  'violent_ideation_intent',
  'mental_emotional_distress',
];
